import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr, localizedStatic } from "@/i18n/copy";
import { Link } from "react-router-dom";
import { UsersRound } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const AGENT_ROLES = localizedStatic([
  { id: "manager", title: "Agent Manager", description: "Agenda, clienti, pratiche e coordinamento del Team." },
  { id: "marketing", title: "Agent Marketing", description: "Campagne, contenuti, pubblico e risultati commerciali." },
], [[0,"title"],[0,"description"],[1,"title"],[1,"description"]]);

export default function AgentModuleSection() {
  useUiLanguage();
  return <section id="agent" aria-labelledby="agent-module-title" className="scroll-mt-6">
    <div className="flex items-center gap-3">
      <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-primary/10"><UsersRound className="h-5 w-5 text-primary" /></span>
      <div>
        <h2 id="agent-module-title" className="font-display text-xl font-semibold">{tr("Agent")}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{tr("Due ruoli dedicati per coordinare le attività e far crescere lo Studio.")}</p>
      </div>
    </div>
    <div className="tps-people-grid mt-3">
      {AGENT_ROLES.map(({ id, title, description }) => <Card key={id} className="flex min-h-60 flex-col rounded-2xl bg-card/60 p-4">
        <h3 className="font-display text-lg font-semibold">{title}</h3>
        <p className="mt-1 flex-1 text-sm text-muted-foreground">{description}</p>
        <Button asChild variant="outline" className="mt-4"><Link to={`/agent/${id}`}>{tr("Esplora i moduli")}</Link></Button>
      </Card>)}
    </div>
    <Button asChild variant="outline" className="mt-4"><Link to="/team">{tr("Invita un Agent nel Team")}</Link></Button>
  </section>;
}
